import React from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

export default function Nav() {

  const { t } = useTranslation();
  const location = useLocation();
  const isActive = (path) => location.pathname.startsWith(path);

  let sideBarStatus = localStorage.getItem("rightSidebar");
  const siderBarClass = sideBarStatus === null || sideBarStatus === 'close' ? "" : "active";

  return (
    <nav className={`sidebar sidebar-offcanvas ${siderBarClass}`} id="sidebar">
      <ul className="nav">
        <NavLink className="nav-item" to={"/root"} end>
          <span className="nav-link" >
            <i className="icon-grid menu-icon"></i>
            <span className="menu-title">{t('dashboard')}</span>
          </span>
        </NavLink>
        <Link className={isActive('/root/customer') ? 'nav-item active' : 'nav-item'} to={"/root/customer"}>
          <span className="nav-link" >
            <i className="ti-user menu-icon"></i>
            <span className="menu-title">{t('customer_master')}</span>
          </span>
        </Link>
        <Link className={isActive('/root/vendor') ? 'nav-item active' : 'nav-item'} to={"/root/vendor"}>
          <span className="nav-link" >
            <i className="icon-head menu-icon"></i>
            <span className="menu-title">{t('vendor_master')}</span>
          </span>
        </Link>
        <li className={isActive('/root/product') ? 'nav-item active' : 'nav-item'}>
          <a className="nav-link" data-toggle="collapse" href="#product_ui" aria-expanded="false" aria-controls="product_ui">
            <i className="ti-view-list menu-icon"></i>
            <span className="menu-title">{t('product_master')}</span>
            <i className="menu-arrow"></i>
          </a>
          <div className={`collapse ${isActive('/root/product') ? 'show' : ''}`} id="product_ui">
            <ul className="nav flex-column sub-menu">
              <li className="nav-item"> <Link className="nav-link" to={"/root/product"}>{t('products')}</Link></li>
              <li className="nav-item"> <Link className="nav-link" to={"/root/product/categoryList"}>{t('category')}</Link></li>
            </ul>
          </div>
        </li>
        <Link className={isActive('/root/quotes') ? 'nav-item active' : 'nav-item'} to={"/root/quotes"}>
          <span className="nav-link" >
            <i className="ti-agenda menu-icon"></i>
            <span className="menu-title">{t('quotes')}</span>
          </span>
        </Link>
        <Link className={isActive('/root/invoices') ? 'nav-item active' : 'nav-item'} to={"/root/invoices"}>
          <span className="nav-link" >
            <i className="ti-agenda menu-icon"></i>
            <span className="menu-title">{t('invoices')}</span>
          </span>
        </Link>
        <Link className={isActive('/root/po') ? 'nav-item active' : 'nav-item'} to={"/root/po"}>
          <span className="nav-link" >
            <i className="icon-archive menu-icon"></i>
            <span className="menu-title">{t('purchase_orders')}</span>
          </span>
        </Link>
        <Link className={isActive('/root/bill') ? 'nav-item active' : 'nav-item'} to={"/root/bill"}>
          <span className="nav-link" >
            <i className="ti-receipt menu-icon"></i>
            <span className="menu-title">{t('bill')}</span>
          </span>
        </Link>
        <Link className={isActive('/root/payment') ? 'nav-item active' : 'nav-item'} to={"/root/payment"}>
          <span className="nav-link" >
            <i className="ti-money menu-icon"></i>
            <span className="menu-title">{t('payment')}</span>
          </span>
        </Link>
        <Link className={isActive('/root/expense') ? 'nav-item active' : 'nav-item'} to={"/root/expense"}>
          <span className="nav-link" >
            <i className="ti-image menu-icon"></i>
            <span className="menu-title">{t('expense')}</span>
          </span>
        </Link>
        <Link className={isActive('/root/credit-note') ? 'nav-item active' : 'nav-item'} to={"/root/credit-note"}>
          <span className="nav-link" >
            <i className="ti-money menu-icon"></i>
            <span className="menu-title">{t('credit_note')}</span>
          </span>
        </Link>
        <Link className={isActive('/root/reports') ? 'nav-item active' : 'nav-item'} to={"/root/reports"}>
          <span className="nav-link" >
            <i className="ti-files menu-icon"></i>
            <span className="menu-title">{t('reports')}</span>
          </span>
        </Link>
        <li className={isActive('/root/setting') ? 'nav-item active' : 'nav-item'}>
          <a className="nav-link" data-toggle="collapse" href="#setting_ui" aria-expanded="false" aria-controls="setting_ui">
            <i className="ti-settings menu-icon"></i>
            <span className="menu-title">{t('setting')}</span>
            <i className="menu-arrow"></i>
          </a>
          <div className={`collapse ${isActive('/root/setting') ? 'show' : ''}`} id="setting_ui">
            <ul className="nav flex-column sub-menu">
              <li className="nav-item"><Link className="nav-link" to={"/root/setting/profile"}>{t('profile')}</Link></li>
              <li className="nav-item"><Link className="nav-link" to={"/root/setting/changePass"}>{t('change_password')}</Link></li>
              <li className="nav-item"><Link className="nav-link" to={"/root/setting/companyDetails"}>{t('company_details')}</Link></li>
              <li className="nav-item"><Link className="nav-link" to={"/root/setting/shortKeys"}>{t('short_keys')}</Link></li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  )
}
